import React from 'react';
import { action, thunk, persist, computed } from 'easy-peasy';
import callApi, { generateUrlParams } from '../helpers/ApiAction';
import { Header } from 'semantic-ui-react';

const state = {
  groups: {
    list: [],
    pagination: {
      per_page: 10,
      current_page: 1,
      last_page: 1,
      total: 0
    }
  },
};

const selectors = {
  groupsDropdown: computed(state => state.groups.list.map(g => ({
    key: `client-group-${g.id}`,
    text: g.name,
    value: g.id,
    content: (
      <Header size="small" content={g.name} subheader={g.description} />
    )
  })))
};

const actions = {
  fetchClientGroups: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: `groups${generateUrlParams(payload)}`,
      method: 'GET'
    });

    const json = await res.json();

    actions.setClientGroupsList(json);
  }),
  setClientGroupsList: action((state, payload) => {
    const {
      data: { groups },
      pagination
    } = payload;

    const { current_page, per_page } = pagination;

    if (current_page === 1 || per_page === 0) {
      state.groups.list = groups;
    } else {
      state.groups.list.push(...groups);
    }

    state.groups.pagination = pagination;
  }),
  buildAllClientsInGroup: thunk(async (_, payload) => {
    const { groupId, branch, environment } = payload;
    
    await callApi({
      endpoint: `groups/${groupId}/build-all`,
      method: 'POST',
      body: {
        branch,
        environment,
      }
    });
  }),
  updateClientGroup: thunk(async (_, payload) => {
    const { groupId, autoSubmit, autoPublish } = payload;

    await callApi({
      endpoint: `groups/${groupId}`,
      method: 'PUT',
      body: {
        auto_submit: !!autoSubmit,
        auto_publish: !!autoPublish,
      }
    })
  }),
  cancelBuildGroup: thunk(async (_, payload) => {
    const { id, callbacks } = payload;
    await callApi({
      endpoint: `builds/groups/${id}`,
      method: 'DELETE',
      callbacks,
    })
  }),
};

export default persist(
  {
    ...state,
    ...selectors,
    ...actions
  },
);
